import APIService from '@/services/APIService';

export default {
  getInfo(id, params) {
    return APIService.get(`/organizations/${id}`, { params });
  },
};
